import * as Yup from "yup";

const nameValid = (value) => /^[a-z ,.'-]+$/i.test(value);
const phoneRegExp =
  /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/;

const SchemaConfig = {
  name: Yup.string()
    .required("Required")
    .test("Name format", "Name format is not valid", nameValid),
  email: Yup.string().required("Required").email("Wrong email format"),
  phone: Yup.string()
    .required("Required")
    .matches(phoneRegExp, "Phone number is not valid"),
  role: Yup.string().required("Required"),
};

const ValidationRules = (initValues) => {
  const filtered = Object.keys(SchemaConfig)
    .filter((key) => Object.keys(initValues).includes(key))
    .reduce((obj, key) => {
      obj[key] = SchemaConfig[key];
      return obj;
    }, {});
  return Yup.object().shape(filtered);
};
export default ValidationRules;
